module.exports = __webpack_public_path__ + "static/media/rebirth_9.ad8ff9e5.jpg";